export const formatString = (str = '') => str.replace(/\*([^*]+)\*/g, '<u>$1</u>')
